import { IHeaderParams } from "@ag-grid-community/core";
import { useCallback, useEffect, useState } from "react";

export type ColumnSortState = "asc" | "desc";

export const useDataTableColumnSortProps = (props: IHeaderParams) => {
  const [columnSort, setColumnSort] = useState(() => props.column.getSort());

  const progressSort = props.progressSort;
  const onClickColumnSort = useCallback(() => {
    if (props.column.getColDef().sortable) {
      progressSort();
    }
  }, [progressSort, props.column]);

  useEffect(() => {
    const listener = () => {
      setColumnSort(props.column.getSort());
    };
    props.column.addEventListener("sortChanged", listener);
    return () => {
      props.column.removeEventListener("sortChanged", listener);
    };
  }, [props.column]);

  return { columnSort, onClickColumnSort };
};
